import { createSelector } from '@reduxjs/toolkit'
import { PortalTypesEnum } from 'shared/models/BBL'
import bblApi from './bbl.service'

const selector = bblApi.endpoints.getBbl.select()

export const getBbl = selector
export const getBblSettings = createSelector(
  selector,
  (state) => state.data?.settings
)
export const getBblUrls = createSelector(
  selector,
  (state) => state.data?.settings?.urls
)
export const isForkjopActive = createSelector(selector, (state) =>
  state.data?.applications?.some(({ name }) => name === PortalTypesEnum.Forkjop)
)

export const isMypageActive = createSelector(selector, (state) =>
  state.data?.applications?.some(({ name }) => name === PortalTypesEnum.MinSide)
)

export const getBblDisplayNames = createSelector(selector, (state) => ({
  portalShort:
    state.data?.settings?.displayNames?.portalDisplayNameShort || 'Portalen',
  portal: state.data?.settings?.displayNames?.portalDisplayName || 'Portalen',
  myPage: state.data?.settings?.displayNames?.myPageDisplayName || 'Min side',
  myPageShort:
    state.data?.settings?.displayNames?.myPageDisplayNameShort || 'Min side',
}))
